import { dateLocale, t } from '@/lib/i18n'

/** The school calendar is Kuwait's (`SCHOOL_TZ` in the API, no daylight saving): a due date reads the same wherever it is opened. */
export const SCHOOL_TIME_ZONE = 'Asia/Kuwait'

const KUWAIT_OFFSET_MS = 3 * 3_600_000
const schoolYear = (date: Date): number => new Date(date.getTime() + KUWAIT_OFFSET_MS).getUTCFullYear()

/** "30 October", with the year only when it is not this year (school time). Western digits in both languages. */
export function formatTaskDate(value: Date, now: Date = new Date()): string {
  return new Intl.DateTimeFormat(dateLocale(), {
    day: 'numeric',
    month: 'long',
    ...(schoolYear(value) === schoolYear(now) ? {} : { year: 'numeric' }),
    timeZone: SCHOOL_TIME_ZONE,
  }).format(value)
}

/** "Due 30 October" or, once it has passed and the task is still open, "Overdue since 30 October". */
export function dueLine(due: Date, overdue: boolean): string {
  return overdue ? t('Overdue since {0}', { 0: formatTaskDate(due) }) : t('Due {0}', { 0: formatTaskDate(due) })
}
